<div class="app-root">
  <div class="app-header">
    <div class="header-section left-elements">
      <h1 class="app-title">
        <img
          class="app-icon app-icon-svg"
          *ngIf="appIconUrl != null"
          [src]="appIconUrl"
        />
        {{ appTitle }}
        <span *ngIf="env" class="env-badge" [ngClass]="env">{{ env }}</span>
        <span *ngIf="region" class="env-badge" [ngClass]="region">{{
          region
        }}</span>
      </h1>
    </div>
    <div class="header-section right-elements">
      <div class="actions">
        <ng-content select="hs-app-header-button-container"></ng-content>
        <ng-content select="hs-app-header-button"></ng-content>
        <div ngbDropdown container="body">
          <button
            nf-icon-button
            icon="cog"
            class="additional-actions"
            id="additional-actions"
            ngbDropdownToggle
          >
            Additional Actions
          </button>
          <span id="hs-error-indicator" *ngIf="errorLogSize > 0"></span>
          <div ngbDropdownMenu aria-labelledby="additional-actions">
            <ng-content select="hs-app-gear-action"></ng-content>
          </div>
        </div>
        <ng-content select="[hsAppHeaderEnd]"></ng-content>
      </div>
    </div>
  </div>

  <div class="app-container card">
    <ng-content select="nf-panel-container"></ng-content>
  </div>
</div>
<ng-content select="hs-app-footer"></ng-content>
